import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function fmtTime12(ts) {
  if (!ts) return "—";
  try {
    return new Date(ts).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true });
  } catch { return "—"; }
}

export function isLate(ts, lateAfter) {
  if (!ts || !lateAfter) return false;
  try {
    const d = new Date(ts);
    const [hh, mm] = lateAfter.split(":").map(Number);
    return d.getHours() > hh || (d.getHours() === hh && d.getMinutes() > mm);
  } catch { return false; }
}

export function isEarly(ts, exitBefore) {
  if (!ts || !exitBefore) return false;
  try {
    const d = new Date(ts);
    const [hh, mm] = exitBefore.split(":").map(Number);
    return d.getHours() < hh || (d.getHours() === hh && d.getMinutes() < mm);
  } catch { return false; }
}
